import React, { memo, useEffect, useRef, useState } from "react";
import style from "./assessmentDetail.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { updatepatientassessmentcustomlabels } from "../../../app/patientSlice";
import { useParams } from "react-router-dom";
import { useReadOnly } from "../../../hooks/useReadOnly";

const CustomLabels = () => {
  const dispatch = useDispatch();
  const { assessmentId, patientId } = useParams();
  const isReadOnly = useReadOnly();
  const detailAssessment = useSelector((state) => state.patient.detailAssessment);

  const [tags, setTags] = useState(["", ""]);
  const [hover, setHover] = useState("notdisplayed");
  const [labelValue, setLabelValue] = useState("");

  const inputRef = useRef(null);

  useEffect(() => {
    document.getElementById("labelID")?.blur();
  }, []);

  useEffect(() => {
    if (!detailAssessment) {
      setTags(["", ""]);
      return;
    }

    const injuryType = !detailAssessment.injuryType || detailAssessment.injuryType === "null" ? "" : detailAssessment.injuryType;
    const bodyType = !detailAssessment.bodyType || detailAssessment.bodyType === "null" ? "" : detailAssessment.bodyType;

    setTags([injuryType, bodyType]);
  }, [detailAssessment]);

  useEffect(() => {
    if (hover === "displayed") {
      inputRef.current?.focus();
    }
  }, [hover]);

  const showXicon = () => setHover("displayed");
  const hideXicon = () => setHover("notdisplayed");

  const dispatchLabels = (injuryType, bodyType) => {
    dispatch(
      updatepatientassessmentcustomlabels({
        patientId,
        assessmentId,
        injuryType,
        bodyType,
      })
    );
  };

  const applyTagValue = (rawValue) => {
    const value = rawValue?.trim();
    setLabelValue("");
    if (!value) return;

    const [tag0, tag1] = tags;

    if (!tag0 && !tag1) {
      setTags([value, ""]);
      dispatchLabels(value, null);
      return;
    }

    if (tag0 && !tag1) {
      setTags([tag0, value]);
      dispatchLabels(tag0, value);
      return;
    }

    if (!tag0 && tag1) {
      setTags([value, tag1]);
      dispatchLabels(value, tag1);
    }
  };

  const handleTags = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      applyTagValue(event.target.value);
      event.target.blur();
    }
  };

  const onTakeValue = (event) => {
    applyTagValue(event?.target?.value);
  };

  const removeTags = (index) => {
    const updatedTags = [...tags];
    updatedTags[index] = "";

    setTags(updatedTags);
    dispatchLabels(updatedTags[0] || null, updatedTags[1] || null);
  };

  const removeTagsTotal = () => {
    setTags(["", ""]);
    dispatchLabels(null, null);
  };

  const hasAnyTag = tags.some(Boolean);
  const showInput = tags.length <= 2 && (tags[0] === "" || tags[1] === "");
  const tagContainerClass = hasAnyTag ? style.tags : style.tagsCompleted;

  return (
    <div className={`${style.assess_content} d-flex`}>
      <span className={`${style.assess_label} pt-4`}>Labels: &#173;</span>
      <span className={`ml-2 align-self-center ${(detailAssessment?.assessmentStage === "signedlocked" || isReadOnly) ? style.label_disabled : ""}`}>
        <div className={tagContainerClass} onMouseOver={showXicon} onMouseOut={hideXicon} ref={inputRef}>
          {tags.map(
            (tag, index) =>
              tag && (
                <div key={index} className={`${style.single_tag}`}>
                  <span className={style.tagsValue}>{tag}</span>
                  <span className={`${style.x_icon}`}>
                    <i
                      className={hover === "displayed" ? "fa fa-times" : ""}
                      onClick={() => removeTags(index)}
                      data-testid="singleIcon"
                      style={{ color: "#000" }}
                      aria-hidden="true"
                    ></i>
                  </span>
                </div>
              )
          )}

          {showInput && (
            <>
              <input
                className={`${style.labelInput} onblurKeyword`}
                id="labelID"
                type="text"
                value={labelValue}
                onChange={(e) => setLabelValue(e.target.value)}
                onKeyDown={handleTags}
                onBlur={onTakeValue}
                placeholder={"+ Add custom"}
                ref={inputRef}
                maxLength="25"
              />
            </>
          )}
          {hasAnyTag && (
            <div className={`${style.delteWhole} onmouseoverKeyword`} onMouseOver={showXicon} onMouseOut={hideXicon}>
              <i
                className={hover === "displayed" ? "fa fa-times-circle" : ""}
                data-testid="iconshow"
                onClick={removeTagsTotal}
                style={{ color: "#000", fontSize: "18px" }}
                aria-hidden="true"
              ></i>
            </div>
          )}
        </div>
      </span>
    </div>
  );
};

export default memo(CustomLabels);
